import { render, staticRenderFns } from "./BankAccounts.vue?vue&type=template&id=35eb5296"
import script from "./BankAccounts.vue?vue&type=script&lang=js"
export * from "./BankAccounts.vue?vue&type=script&lang=js"
import style0 from "./BankAccounts.vue?vue&type=style&index=0&id=35eb5296&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports